import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4 text-white" }
const _hoisted_2 = { class: "flex flex-col items-center" }
const _hoisted_3 = { class: "text-center py-1 min-w-[2ch] text-md" }
const _hoisted_4 = { class: "flex flex-col items-center" }
const _hoisted_5 = { class: "text-center py-1 min-w-[2ch] text-md" }

import { ref, watch } from 'vue';
import { ChevronDown, ChevronUp } from 'lucide-vue-next';
import Button from '../button/Button.vue';

interface Props {
  modelValue?: string;
  disabled?: boolean;
}

interface Emits {
  (e: 'update:modelValue', value: string): void;
  (e: 'change', value: string): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TimePicker',
  props: {
    modelValue: { default: '00:00' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Parse initial hours and minutes from modelValue
const parseInitialTime = () => {
  const [hoursStr, minutesStr] = props.modelValue.split(':');
  return {
    hours: parseInt(hoursStr) || 0,
    minutes: parseInt(minutesStr) || 0
  };
};

const hours = ref(parseInitialTime().hours);
const minutes = ref(parseInitialTime().minutes);

// Increment/decrement functions with limits
const incrementHours = () => {
  if (props.disabled) return;
  hours.value = (hours.value + 1) % 24;
  emitTimeChange();
};

const decrementHours = () => {
  if (props.disabled) return;
  hours.value = (hours.value - 1 + 24) % 24;
  emitTimeChange();
};

const incrementMinutes = () => {
  if (props.disabled) return;
  minutes.value = (minutes.value + 1) % 60;
  emitTimeChange();
};

const decrementMinutes = () => {
  if (props.disabled) return;
  minutes.value = (minutes.value - 1 + 60) % 60;
  emitTimeChange();
};

// Format time values with leading zeros
const formattedHours = () => hours.value.toString().padStart(2, '0');
const formattedMinutes = () => minutes.value.toString().padStart(2, '0');

// Emit time change events
const emitTimeChange = () => {
  const timeString = `${formattedHours()}:${formattedMinutes()}`;
  emit('update:modelValue', timeString);
  emit('change', timeString);
};

// Watch for external changes to modelValue
watch(() => props.modelValue, (newValue) => {
  const { hours: newHours, minutes: newMinutes } = parseInitialTime();
  hours.value = newHours;
  minutes.value = newMinutes;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Button, {
        variant: "outline",
        size: "icon",
        class: "h-8 w-8 rounded-md",
        onClick: incrementHours,
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronUp), { class: "h-4 w-4" })
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString(formattedHours()), 1),
      _createVNode(Button, {
        variant: "outline",
        size: "icon",
        class: "h-8 w-8 rounded-md",
        onClick: decrementHours,
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronDown), { class: "h-4 w-4" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-md font-medium" }, ":", -1)),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Button, {
        variant: "outline",
        size: "icon",
        class: "h-8 w-8 rounded-md",
        onClick: incrementMinutes,
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronUp), { class: "h-4 w-4" })
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(formattedMinutes()), 1),
      _createVNode(Button, {
        variant: "outline",
        size: "icon",
        class: "h-8 w-8 rounded-md",
        onClick: decrementMinutes,
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ChevronDown), { class: "h-4 w-4" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})